import { Component, EventEmitter, HostListener, Input, OnInit, Output } from '@angular/core';
import { TunnelStep } from '../../../../models/tunnel-step.model';
import { FaDirectiveEnum } from '../../../../models/enums/fa-directive.enum';
import { RouterLink, RouterLinkActive, RouterOutlet } from '@angular/router';
import { NgForOf, NgIf } from '@angular/common';
import { BaryIconComponent } from '../bary-icon/bary-icon.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'jhi-bary-outlet-tabs[steps]',
  standalone: true,
  imports: [RouterLink, NgForOf, NgIf, BaryIconComponent, TranslateModule, RouterOutlet, RouterLinkActive],
  templateUrl: './bary-outlet-tabs.component.html',
  styleUrls: ['./bary-outlet-tabs.component.scss'],
})
export class BaryOutletTabsComponent implements OnInit {
  @Input() steps!: TunnelStep[];
  @Input() stepper = false;
  @Input() class = 'tab-content';
  @Input() active = 0;

  @Output() activateEvent = new EventEmitter<any>();
  @Output() activeChange = new EventEmitter();

  protected readonly FAS = FaDirectiveEnum.FAS;

  private innerWidth = 0;

  get mainClasses(): string {
    return this.stepper ? '' : 'classic-tabs';
  }

  get ulClasses(): string {
    return this.stepper ? `stepper linear${this.innerWidth < 768 ? '' : ' horizontal'}` : 'nav';
  }

  get liClasses(): string {
    return this.stepper ? 'step mb-0' : 'nav-item mb-3';
  }

  get aClasses(): string {
    return this.stepper ? 'step-title' : 'nav-link';
  }

  public handleActivate($event: any): void {
    this.activateEvent.emit($event);
  }

  public ngOnInit(): void {
    this.innerWidth = window.innerWidth;
  }

  @HostListener('window:resize', ['$event'])
  public onResize(event: any): void {
    this.innerWidth = window.innerWidth;
  }
}
